import { IReportTamThuRequest } from "../../../model/request/report/IReportTamThuRequest";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IReportTamThuViewModel } from "../../../model/respone/report/IReportTamThuRespone";
import { IReportTamThuActionTypes } from "../../action-types/report/IReportTamThuActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IReportTamThuReducer } from "../../reducer-model/report/IReportTamThuReducer";

const iniState: IReportTamThuReducer = {
  status: eReducerStatusBase.is_not_initialization,
  reports: {} as IPagingResult<IReportTamThuViewModel[]>,
  isShowFilter: false,
  request: {
    id_hes: [],
    id_khoas: [],
    id_lops: [],
    id_nganhs: [],
    id_thu_chis: [],
    khoa_hocs: [],
    page_index: 0,
    page_size: 20,
    search_key: "",
  } as IReportTamThuRequest,
};
export const reportTamThuReducer = (
  state: IReportTamThuReducer = iniState,
  action: IReportTamThuActionTypes
): IReportTamThuReducer => {
  switch (action.type) {
    case "REPORT_TAM_THU_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "REPORT_TAM_THU_LOAD_SUCCESS":
      return {
        ...state,
        reports: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "REPORT_TAM_THU_LOAD_ERROR":
      return {
        ...state,
        reports: {} as IPagingResult<IReportTamThuViewModel[]>,
        status: eReducerStatusBase.is_completed,
      };
    case "REPORT_TAM_THU_CHANGE_REQUEST":
      return {
        ...state,
        reports: {} as IPagingResult<IReportTamThuViewModel[]>,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    case "REPORT_TAM_THU_SHOW_MODAL_LIST_BIEN_LAI":
      return {
        ...state,
        isShowListBienLai: true,
        idSinhVien: action.payload,
      };
    case "REPORT_TAM_THU_CLOSE_MODAL_LIST_BIEN_LAI":
      return {
        ...state,
        isShowListBienLai: false,
      };
    case "REPORT_TAM_THU_SHOW_HIDE_FILTER":
      return {
        ...state,
        isShowFilter: action.payload,
      };
    default:
      return state;
  }
};
